import { useHouseholdSize } from '@hooks/useHouseholdSize';
import { prismicRichTextContentSerializer } from '@monofront/business/utils/prismicRichTextContentSerializer';
import { PrismicContentSerializer } from '@monofront/types';
import { useMemo } from 'react';

export const useHouseholdSizeSerializer = (): PrismicContentSerializer => {
  const { size } = useHouseholdSize();

  return useMemo(
    () => prismicRichTextContentSerializer({ HOUSEHOLD_SIZE: String(size) }),
    [size],
  );
};
